import { saveAs } from 'file-saver'
import { isNative } from './isNative'
import { FileOpener } from '@capacitor-community/file-opener'
import { Filesystem, Directory } from '@capacitor/filesystem'

function base64ToArrayBuffer(base64: string) {
  const binaryString = window.atob(base64) // Comment this if not using base64
  const bytes = new Uint8Array(binaryString.length)
  return bytes.map((byte, i) => binaryString.charCodeAt(i))
}

export async function download(filename: string, data: any, mimeType: string) {
  // Handle apps.
  if (isNative()) {
    let filePath
    try {
      const file = await Filesystem.writeFile({
        data,
        path: filename,
        directory: Directory.Documents,
      })
      filePath = file.uri
    } catch (e) {
      console.error('Error writing file', e)
      alert('Saving file failed')
    }
    if (filePath) {
      try {
        await FileOpener.open({
          filePath,
          contentType: mimeType,
        })
      } catch (e) {
        console.error('Error opening file', e)
        alert('Opening file failed')
      }
    }
  } else {
    // Handle browser.
    const arrayBuffer = base64ToArrayBuffer(String(data))
    const blob = new Blob([arrayBuffer], {
      type: mimeType,
    })
    saveAs(blob, filename)
  }
}
